var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2C6.47715 2 2 6.47714 2 12C2 17.5229 6.47715 22 12 22ZM7.44 12C7.44 9.47754 9.46175 7.44 12 7.44C13.5477 7.44 14.7101 8.08215 15.4997 8.74149C15.5783 8.80707 15.6529 8.87265 15.7237 8.93759H14.9376C14.54 8.93759 14.2176 9.25995 14.2176 9.65759C14.2176 10.0552 14.54 10.3776 14.9376 10.3776H17.28C17.6776 10.3776 18 10.0552 18 9.65759V7.01761C18 6.61996 17.6776 6.29761 17.28 6.29761C16.8824 6.29761 16.56 6.61996 16.56 7.01761V7.75354C16.5154 7.71445 16.4696 7.67529 16.4227 7.63611C15.4531 6.82663 13.9755 6 12 6C8.66305 6 6 8.68567 6 12C6 12.3976 6.32236 12.72 6.72 12.72C7.11765 12.72 7.44 12.3976 7.44 12ZM18 12C18 11.6024 17.6776 11.28 17.28 11.28C16.8824 11.28 16.56 11.6024 16.56 12C16.56 14.5208 14.5208 16.56 12 16.56C10.7908 16.56 9.78296 15.9506 9.0424 15.2782C8.96296 15.206 8.88734 15.1338 8.81565 15.0624H9.68639C10.084 15.0624 10.4064 14.7401 10.4064 14.3424C10.4064 13.9448 10.084 13.6224 9.68639 13.6224H7.30559C6.90794 13.6224 6.58559 13.9448 6.58559 14.3424V16.9824C6.58559 17.38 6.90794 17.7024 7.30559 17.7024C7.70323 17.7024 8.02559 17.38 8.02559 16.9824V16.2996L8.07439 16.3442C8.95143 17.1406 10.2907 18 12 18C15.316 18 18 15.316 18 12Z",
    fill: "#1671ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusInProgress);
export default __webpack_public_path__ + "static/media/StatusInProgress.22e89baa.svg";
export { ForwardRef as ReactComponent };